module.exports = __webpack_public_path__ + "static/img/buy.03644b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buy.jpg
// module id = WJFQ
// module chunks = 0